import { SnapshotRow, RunAuditRecord } from '../types/borrowerChecker'

function formatTimestampForFilename(isoString: string): string {
  const d = new Date(isoString)
  const year = d.getUTCFullYear()
  const month = String(d.getUTCMonth() + 1).padStart(2, '0')
  const day = String(d.getUTCDate()).padStart(2, '0')
  const hours = String(d.getUTCHours()).padStart(2, '0')
  const minutes = String(d.getUTCMinutes()).padStart(2, '0')
  const seconds = String(d.getUTCSeconds()).padStart(2, '0')
  return `${year}${month}${day}_${hours}${minutes}${seconds}`
}

function escapeCsvField(value: string): string {
  if (value.includes(',') || value.includes('"') || value.includes('\n')) {
    return `"${value.replace(/"/g, '""')}"`
  }
  return value
}

export function getMissingLoansFilename(timestamp: string): string {
  return `MissingLoans_${formatTimestampForFilename(timestamp)}.csv`
}

export function getRunAuditFilename(timestamp: string): string {
  return `RunAudit_${formatTimestampForFilename(timestamp)}.csv`
}

export function generateMissingLoansCSV(missingRecords: SnapshotRow[]): string {
  const headers = [
    'Row Number',
    'Lender Loan ID',
    'Borrower Name',
    'Loan Amount',
    'Loan Date',
    'Property Address',
    'Loan Type',
  ]
  const rows = missingRecords.map((record) => [
    String(record.rowNumber),
    escapeCsvField(record.lenderLoanId),
    escapeCsvField(record.borrowerName),
    escapeCsvField(record.loanAmount),
    escapeCsvField(record.loanDate),
    escapeCsvField(record.propertyAddress),
    escapeCsvField(record.loanType),
  ])

  return [headers.join(','), ...rows.map((r) => r.join(','))].join('\n')
}

export function generateRunAuditCSV(auditRecord: RunAuditRecord): string {
  const headers = [
    'Run Timestamp (UTC)',
    'Running User ID',
    'Running User Name',
    'Running User Email',
    'Snapshot Filename',
    'Total Row Count',
    'Valid Row Count',
    'Matched Count',
    'Missing Count',
    'Duplicate Count',
    'Validation Error Count',
    'Missing Report Filename',
    'Status',
    'Error Message',
  ]

  const values = [
    escapeCsvField(auditRecord.runTimestamp),
    escapeCsvField(auditRecord.runningUserId),
    escapeCsvField(auditRecord.runningUserName),
    escapeCsvField(auditRecord.runningUserEmail),
    escapeCsvField(auditRecord.snapshotFilename),
    String(auditRecord.totalRowCount),
    String(auditRecord.validRowCount),
    String(auditRecord.matchedCount),
    String(auditRecord.missingCount),
    String(auditRecord.duplicateCount),
    String(auditRecord.validationErrorCount),
    escapeCsvField(auditRecord.missingReportFilename),
    escapeCsvField(auditRecord.status),
    escapeCsvField(auditRecord.errorMessage),
  ]

  return [headers.join(','), values.join(',')].join('\n')
}

export function downloadCSV(content: string, filename: string): void {
  const blob = new Blob([content], { type: 'text/csv;charset=utf-8;' })
  const url = URL.createObjectURL(blob)
  const link = document.createElement('a')
  link.href = url
  link.download = filename
  link.style.display = 'none'
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
  URL.revokeObjectURL(url)
}

export function estimateFileSize(content: string): string {
  const bytes = new Blob([content]).size
  if (bytes < 1024) return `${bytes} B`
  if (bytes < 1024 * 1024) return `${(bytes / 1024).toFixed(1)} KB`
  return `${(bytes / (1024 * 1024)).toFixed(1)} MB`
}
